import Detail from './detail';
import Create from './create';
import Edit from './edit';

export default { Detail, Create, Edit };

